module.exports = __webpack_public_path__ + "static/media/rishabhV.c9a259a3.jpeg";